export default __webpack_public_path__ + "e0acf4ae7ab4365188d722c39bece187.png";